export const getShopInfosInStorage = () => {
    if (typeof (sessionStorage) !== 'undefined') {
        const shopInfos = sessionStorage.getItem('shopInfos');
        if (shopInfos) {
            return JSON.parse(shopInfos);
        }
    }
};
